import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-assistance-case-times',
    templateUrl: './assistance-case-times.component.html',
    styleUrls: ['./assistance-case-times.component.css'],
    standalone: false
})
export class AssistanceCaseTimesComponent {

  @Input() assistancecase;
  @Output() case = new EventEmitter<{}>();
  @Output() client = new EventEmitter<{}>();
  @Output() operator = new EventEmitter<{}>();
  @Output() dispatcher = new EventEmitter<{}>();
  @Output() provider = new EventEmitter<{}>();

  assistancecase_color = new Map;
  assistancecaseClient_color = new Map;
  assistancecaseOperator_color = new Map;
  assistancecaseDispatcher_color = new Map;
  assistancecaseProvider_color = new Map;

  constructor() { }

  setColorValue(obj){
    this.case.emit(obj)
    this.assistancecase_color.set(obj.id,obj.color);
  }

  getColorValue(id){
    return this.assistancecase_color.get(id)
  }

  setColorClientValue(obj){
    this.client.emit(obj)
    this.assistancecaseClient_color.set(obj.id,obj.color);
  }

  getColorClientValue(id){
    return this.assistancecaseClient_color.get(id)
  }

  setColorOperatorValue(obj){
    this.operator.emit(obj)
    this.assistancecaseOperator_color.set(obj.id,obj.color);
  }

  getColorOperatorValue(id){
    return this.assistancecaseOperator_color.get(id)
  }

  setColorDispatcherValue(obj){
    this.dispatcher.emit(obj)
    this.assistancecaseDispatcher_color.set(obj.id,obj.color);
  }

  getColorDispatcherValue(id){
    return this.assistancecaseDispatcher_color.get(id)
  }

  setColorProviderValue(obj){
    this.provider.emit(obj)
    this.assistancecaseProvider_color.set(obj.id,obj.color);
  }

  getColorProviderValue(id){
    return this.assistancecaseProvider_color.get(id)
  }

}
